import {
  SetMutedAPI,
  EndCallAPI,
  EditCallNameAPI,
  ShowNpsAPI,
  SET_MUTED,
  END_CALL,
  EDIT_CALL_NAME,
  SHOW_NPS,
  Exceptions,
  GetJoinRoomCredentialsAPI,
  GET_JOIN_ROOM_CREDENTIALS,
} from '@weblite-wapps/protocol'
import { CallType } from '@weblite/ts-action/media-proxy'
import { RoomTypes } from '@weblite/ts-action/room'
import { showCallEndedSnackbar } from '$comp/snackbars'
import {
  callService,
  callStorage,
  resetCallAndShowNPS,
  // showCallNPSByWapp,
} from '$logic/call'
import { wappSubscription } from '../helper/subscription-handler'
import { sendEventToTwa } from '$logic/twaCommunication/twaCommunication.api'
import { TWA_EVENTS } from '$logic/twaCommunication'

wappSubscription.subscribe<SetMutedAPI>(SET_MUTED, ({ muted }) => {
  callStorage.set({ muted })
  return { status: 'ok' }
})

wappSubscription.subscribe<EditCallNameAPI>(
  EDIT_CALL_NAME,
  async ({ name }) => {
    if (!name) return { errorCode: Exceptions.FAILED }

    try {
      await callService.editCallName(name)
    } catch (err) {
      return { errorCode: Exceptions.FAILED }
    }

    return { status: 'ok' }
  },
)

wappSubscription.subscribe<EndCallAPI>(END_CALL, async payload => {
  sendEventToTwa(TWA_EVENTS.END_ONGOING_CALL)
  const { reason, reasonType } = payload ?? {}

  await resetCallAndShowNPS(undefined, false)

  if (reason) showCallEndedSnackbar(reason, reasonType)
  return { status: 'ok' }
})

wappSubscription.subscribe<ShowNpsAPI>(
  SHOW_NPS,
  async ({ callType, roomId, startedAt }) => {
    if (!callType || !roomId || !startedAt)
      return { errorCode: Exceptions.INVALID }

    // showCallNPSByWapp({ callType, roomId, startedAt })
    return { status: 'ok' }
  },
)

wappSubscription.subscribe<GetJoinRoomCredentialsAPI>(
  GET_JOIN_ROOM_CREDENTIALS,
  async payload => {
    const { callType, roomId, roomType } = payload

    const res = await callService.getJoinRoomCredentials(
      roomId,
      roomType as RoomTypes,
      callType as CallType,
    )

    if (!res) return { errorCode: Exceptions.NOT_ALLOWED }

    return { token: res.token, serverAddress: res.serverAddress }
  },
)
